<div class="font-semibold text-sm px-8 py-2 flex justify-between items-center">
  <div class="text-basic-300 flex gap-4">
    @for (document of docs() | senetDocuments: userGroup() : translateService.currentLang : orgLang(); track $index) {
      <button
        (click)="openDocument(document)"
        class="underline hover:text-basic-100 transition-colors duration-300"
        type="button">
        {{ document.documentName }}
      </button>
    }
  </div>

  <div class="flex gap-4 items-center">
    <sid-language />
    <div class="cursor-default text-basic-400">&copy;SENET {{ year }}</div>
  </div>
</div>
